import {
  Gender,
  ConsultationTarget,
  DraftMessageStatus,
  MessageStatus,
} from '@/graphql/types'

type Format =
  | Gender
  | ConsultationTarget
  | DraftMessageStatus
  | MessageStatus
  | null
  | undefined
type EnumType =
  | 'Gender'
  | 'ConsultationTarget'
  | 'DraftMessageStatus'
  | 'MessageStatus'
export const convertEnum = (
  enumString: EnumType,
  value: Format,
  forDoctor = false
): string => {
  let displayString = ''
  switch (enumString) {
    case 'Gender':
      if (value === Gender.Male) {
        displayString = '男性'
        break
      } else if (value === Gender.Female) {
        displayString = '女性'
        break
      }
      break
    case 'ConsultationTarget':
      if (forDoctor) {
        if (value === ConsultationTarget.Myself) {
          displayString = 'ご本人'
          break
        } else if (value === ConsultationTarget.Others) {
          displayString = 'ご本人以外'
          break
        }
      } else {
        if (value === ConsultationTarget.Myself) {
          displayString = '私自身（相談者本人）'
          break
        } else if (value === ConsultationTarget.Others) {
          displayString = '私以外の方（ ご家族やご友人、ケアに関わる方など）'
          break
        }
      }
      break

    case 'DraftMessageStatus':
      break
    case 'MessageStatus':
      break
    default:
  }

  return displayString
}

export const turncateString = (
  str: string | undefined,
  length: number
): string => {
  if (str) {
    return str.length <= length ? str : str.substr(0, length) + '...'
  } else {
    return ''
  }
}
